import React from "react";
import { Box, Container } from "@chakra-ui/react";
import SideRail, { RAIL_WIDTH } from "./SideRail";
import { useAuth } from "../hooks/useAuth";
import { useUser } from "../contexts/UserContext";
import ManagerShell from "./manager/ManagerShell";

// App shell: a thin fixed left icon rail + the routed content area. The rail is
// position:fixed, so the content keeps normal window scroll (sticky headers in
// pages still anchor to the viewport) and just sits to the right of the rail.
const PageLayoutWithHeaderNav = ({ children, maxWidth = "container.xl" }) => {
  const { userName, handleLogout, handleEditSignature } = useAuth();
  const { userInfo, isAdmin } = useUser();
  const isManager = userInfo?.role === "manager" && !isAdmin;

  if (isManager) {
    return (
      <ManagerShell
        maxWidth={maxWidth}
        userName={userName}
        onSignOut={handleLogout}
        userInfo={userInfo}
      >
        {children}
      </ManagerShell>
    );
  }

  return (
    <Box minH="100vh" bg="gray.50">
      <SideRail
        onSignOut={handleLogout}
        onEditSignature={handleEditSignature}
        userName={userName}
      />
      <Box ml={RAIL_WIDTH}>
        <Container maxW={maxWidth} py={6}>
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export default PageLayoutWithHeaderNav;
